
export const defaultKeywords = ``;

export const defaultFilters = {
    year: "",
    location: [],
    topic: [],
    affs: [],
    experts: [],
    advBoard: "",
    isActive: "",
    advanceSort: [],
    listType: {
        label: "SHORT LIST",
        value: "SHORT_LIST"
    },
    isActive:{},
    operator:  { value: "OR", label: "OR" },
    addedBy: [],
    size: 10,
    from: 0,
    sort: {
        value: "citation_count",
        label: "Total Related Citation"
      },
      sorting: {},
      public_bio: "",
      contact_details: "",
      clinician: "",
      accreditations: "",
      positions_of_responsibility: "",
      scientific_advisory_board: "",
      principal_investigator: "",
      presence_on_other_channels: "",
      media_presence: "",
      health_orgs: "",
      medical_bodies: "",
      has_patient_group: "",
      has_conference_ds: "",
      has_conference_lgs: "",
      has_conference_others: ""
  }